import React from "react";
import { BlogDetailSec } from "./blog-detail";

export const BlogDetail = () => {
  return (
    <React.Fragment>
      <div className="blog-detail-main">
        <BlogDetailSec />
      </div>
    </React.Fragment>
  );
};
